
<!-- Unity videocall module -->
<canvas id="unityContainer" style="width: 100%; height: 100%" [class.show]="moduleLoaded"></canvas>
